export const getLocalUser = () => {
    const headers = {};

    const authToken = localStorage.getItem('authToken');
    const userId = localStorage.getItem('USER_ID');
    const workspaceId = localStorage.getItem('WORKSPACE_ID');

    if (authToken) {
        // Ensure Bearer prefix is present
        headers['Authorization'] = authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`;
    }
    if (userId) headers['X-USER-ID'] = userId;
    if (workspaceId) headers['X-WORKSPACE-ID'] = workspaceId;

    return headers;
};

// Helper function to check if user is authenticated
export const isAuthenticated = () => {
    return !!localStorage.getItem('authToken');
};

// Helper function to get current user data
export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
        try {
            return JSON.parse(userStr);
        } catch (error) {
            console.error('Error parsing user data:', error);
            return null;
        }
    }
    return null;
};